import { Component } from '@angular/core';

@Component({
  selector: 'app-button-notification-demo',
  templateUrl: './button-notification-demo.component.html',
})
export class ButtonNotificationDemoComponent {}
